/*
 * @Author: your name
 * @Date: 2020-08-02 18:06:20
 * @LastEditTime: 2020-08-02 22:00:52
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/store/select-people.store.js
 */
import TypeUtil from '@/util/type.util.js'
export const SET_SELECTED_ARRAY = 'SET_SELECTED_ARRAY'
export const PUSH_SELECTED_ITEM = 'PUSH_SELECTED_ITEM'
export const POP_SELECTED_ITEM = 'POP_SELECTED_ITEM'
export const REMOVE_SELECTED_ITEM = 'REMOVE_SELECTED_ITEM'
export const PUSH_NAV_ITEM = 'PUSH_NAV_ITEM'
export const POP_NAV_ITEM = 'POP_NAV_ITEM'
export const RESET_PEOPLE_STORE = 'RESET_PEOPLE_STORE'

const selectPeopleStore = {
  namespaced: true,
  state: {
    selectedArray: [],
    navMenu: [{
      name: '全部'
    }]
  },
  mutations: {
    [SET_SELECTED_ARRAY](state, selectedArray) {
      if (TypeUtil.isArray(selectedArray)) {
        state.selectedArray = selectedArray
      }
    },
    [PUSH_SELECTED_ITEM](state, item) {
      if (TypeUtil.isObject(item)) {
        state.selectedArray.push(item)
      }
    },
    [POP_SELECTED_ITEM](state) {
      state.selectedArray.pop()
    },
    [REMOVE_SELECTED_ITEM](state, item) {
      if (TypeUtil.isObject(item)) {
        const index = state.selectedArray.findIndex(_item => _item.id === item.id)
        if (index !== -1) {
          state.selectedArray.splice(index, 1)
        }
      }
    },
    [PUSH_NAV_ITEM](state, menu) {
      if (TypeUtil.isObject(menu)) {
        state.navMenu.push(menu)
      }
    },
    [POP_NAV_ITEM](state) {
      state.navMenu.pop()
    },
    [RESET_PEOPLE_STORE](state) {
      state.selectedArray = []
      state.navMenu = [
        {
          name: '全部'
        }
      ]
    }
  }
}

export default selectPeopleStore
